module.exports = __webpack_public_path__ + "static/media/weapon_dummy.f9edb8c1.svg";